import { Space, Button, Divider, Avatar, Typography, Grid } from "antd";
import R2Footer from "../../../components/Footer";
import { ArrowLeftOutlined, CloseOutlined, LeftOutlined, RightCircleOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import { useState ,useEffect} from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useSelector } from 'react-redux';

import CheckoutForm from "../../../components/CheckoutForm";
import PosService from "../../../services/PosService";
import EmployeeService from "../../../services/EmployeeService";
const { useBreakpoint } = Grid;

const { Title, Text } = Typography;





const Checkout = () => {

	const history = useHistory();
	const screens = useBreakpoint();

	const adminRestaurant = useSelector((state) => state.admin)
	const [carts, setCarts] = useState([])
	const [cartDetails, setCartDetails] = useState()
	const [serverData, setServerData] = useState()
	const [orderIssues, setOrderIssues] = useState()

	const Item = ({ name, quantity, description, sides, price, isLast }) => {
	return (
		<>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					width: "100%",
					marginBottom: !screens.md && "10px"
				}}
			>
				<div style={{ width: "80%", display: "flex" }}>
					<div className="pos-menu-summary-items">
						<div className= {screens.md ? "pos-desktop-quantity" : "pos-mobile-quantity"} >
							{quantity}{" "}
							<CloseOutlined
								style={{ marginLeft: "10px", marginRight: "10px" }}
							/>{" "}
							
						</div>
						<div >
						<div className={screens.md ? "pos-desktop-quantity summary-menus" : "pos-mobile-quantity summary-menus"}>
							{name}
						</div>
						<div className="summary-menus">
							<div type="secondary">
								{description}
							</div>
							<div>
								sides: {sides}
							</div>
						</div>
					</div>
					</div>
				</div>
				<div  className= {screens.md ? "pos-desktop-quantity" : "pos-mobile-quantity"}>${price}</div>
			</div>

			{!isLast && screens.md && (
				<Divider style={{ backgroundColor: "black", opacity: "0.15" }} />
			)}
		</>
	);
};

	useEffect(() => { 
		(async () => {
		 
		   const cartItems = await PosService.getPosCart(adminRestaurant,localStorage.getItem("tableId") && Number(localStorage.getItem("tableId")))
		   setCarts(cartItems?.cart_items.filter(item=>item.quantity != 0))
		   setCartDetails(cartItems)
		   const employee = await EmployeeService.getEmployeeById(localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")))
		   setServerData(employee)
		})();
	  }, []);

	  const checkout = async()=>{
		const payload={
			cart_id : cartDetails?.id,
			time_zone: "US/Central",
			// is_catering: false,
			// customer_location_id: 0,
			// order_type: "POS",
			note: "Please keep the delivery faster",
			server_employee_id: localStorage.getItem("serverId")?Number(localStorage.getItem("serverId")):localStorage.getItem("serverId"),
			host_employee_id: localStorage.getItem('tableHost')? Number(localStorage.getItem('tableHost')):localStorage.getItem('tableHost')
		}
		
		if(orderIssues)
		{
			const order = await PosService.posPlaceOrder(payload)
			orderIssues.order_id = order?.id
		const posOrderIssues = await PosService.posOrderIssue(orderIssues)
		history.push(`/pos/payment?id=${order?.order_num}=${order?.id}`)
		}
		else{
			const order = await PosService.posPlaceOrder(payload)

			history.push(`/pos/payment?id=${order?.order_num}=${order?.id}`)
		}

		
	  }

	return (
		<>
			<div className="container" style={{ background: "#fdf8f9", marginBottom: !screens.md && "150px" }}>
				<div
					style={{
						padding: screens.md? 50: 15,
						width: screens.md ? "75%" : "100%",
						minHeight: 280,
						position: "relative",
					}}
				>
					<Space size={"large"} direction="vertical" style={{ width: "100%" }}>
						<div className={styles.backBtn} >
							{screens.md ?<ArrowLeftOutlined style={{ color: "#C32340" }}
							onClick={()=> history.push(`/pos/menus/server-menu?id=${localStorage.getItem("menuId")}`)} />
							:
							<LeftOutlined style={{ color: "#C32340", fontSize:  "18px" }} 
							onClick={()=> history.push(`/pos/menus/server-menu?id=${localStorage.getItem("menuId")}`)} />}
							<span style={{ fontSize: !screens.md && "18px"}}>Back to Menu</span>
						</div> 
						<div className={styles.dataContainer} style={{padding: !screens.md && "10px"}}>
							<div className={ screens.md ? styles.server :"summary-server"}>
								<Title level={screens.md ?4:5}>SERVER</Title>
								<div className={screens.md ? styles.serverDetails :"summary-server-head"}>
									<Avatar size={45} src={serverData?.photo_url}></Avatar>
									<div className={screens.md ? "" :"code-name"}>
										<Title level={screens.md ? 4: 5} style={{ color: "#C32340" }}>
											{serverData?.name}
										</Title>
										<Text type="secondary">
											Server code:{" "}
											<span style={{ color: "black" }}>
												{serverData?.restaurant_roles.find(item=>item.restaurant_id == adminRestaurant)?.employee_code}
											</span>
										</Text>
										<p></p>
									</div>
								</div>
							</div>
							<Divider style={{ backgroundColor: "black", opacity: !screens.md && "20%" }} />
							<div className={screens.md? styles.summary  :"summary-server"}>
								<Title level={screens.md ? 4: 5}>SUMMARY</Title>
								<div className={screens.md ? styles.items :"summary-items"}>
									{carts?.map((item, index, array) => {
										return (
											<Item
												key={index}
												isLast={index === array.length - 1}
												{...item}
											/>
										);
									})}
								</div>
							</div>
							<Divider style={{ backgroundColor: "black", opacity: !screens.md && "20%"  }} />
						</div>
					</Space>
					<CheckoutForm cartItems={carts} serverData={serverData}
					setOrderIssues={setOrderIssues}/>
				</div>
				{screens.md &&
				<div className={styles.cartBar}>
					<div style={{ padding: "20px 15px" }}>
						<span>Order From</span>
						<Title level={3}>{serverData?.restaurants?.find(item=>item.id == adminRestaurant)?.name}</Title>
						<Text className="theme-red">Table number:{localStorage.getItem("tableNumber")}</Text>
						<hr />
					</div>
					<div style={{ padding: "20px" }}>
						<div className={styles.totalDiv}>
							<Text>Subtotal</Text>
							<Text style={{ fontWeight: "bold" }}>${cartDetails?.price}</Text>
						</div>
						<div className={styles.totalDiv}>
							<Text>Taxes and Fees</Text>
							<Text style={{ fontWeight: "bold" }}>${cartDetails?.taxes}</Text>
						</div>
						<hr />
						<div className={styles.totalDiv}>
							<Text className={styles.totalText}>Total</Text>
							<Text className={styles.totalText}>${cartDetails?.total}</Text>
						</div>
						<div className={styles.checkoutBtn}>
							<Button type="primary"
							onClick={()=> checkout()}>Place Order</Button>
						</div>
					</div>
				</div>
}
{!screens.md &&
        <div className="bottom-fixed-wrapper">
          {/* Top Menu Section */}
          <div className="pos-price-checkout">
           <div className={styles.totalDiv}>
							<Text>Subtotal</Text>
							<Text style={{ fontWeight: "bold" }}>${cartDetails?.price}</Text>
						</div>
						<div className={styles.totalDiv}>
							<Text>Taxes and Fees</Text>
							<Text style={{ fontWeight: "bold" }}>${cartDetails?.taxes}</Text>
						</div>
						<hr />
						<div className={styles.totalDiv}>
							<Text className={styles.totalText}>Total</Text>
							<Text className={styles.totalText}>${cartDetails?.total}</Text>
						</div>
          </div>

          {/* Cart Section */}
          <div className="cart-bar">
           <div></div>

            <div className="cart-right" onClick={()=> checkout()}>
              <span>Proceed to Checkout</span>
              <RightCircleOutlined />
            </div>
          </div>
        </div>
}
			</div>
			<R2Footer />
		</>
	);
};

export default Checkout;
